export default {
  en: {
    banner_title: 'How to watch Netflix videos with PlexVPN?',
    banner_des: 'Your favorite TV show or movie is available on Netflix, but you cannot find it in the Netflix repository in your region? It is because Netflix has different resource libraries in each country/region. If you hope to watch the videos from other regions, you need to use PlexVPN to change your GEO location. PlexVPN has a large number of servers that can help you bypass Netflix’s GEO restrictions and allow you to watch your favorite videos quickly & smoothly.',
    banner_btn: 'Get PlexVPN now',
    benefit_title: 'Advantages of using PlexVPN to watch Netflix',
    benefit_item1: 'Unlock the GEO restrictions, watch the Netflix videos from various countries/regions',
    benefit_item2: 'High-speed & stable servers enable you to watch HD/4K videos smoothly ',
    benefit_item3: 'No traffic limit, the best choice for you to watch Netflix videos',
    getPlex: 'Get PlexVPN',
    downloadPlex: 'Download PlexVPN',
    steps_title: '3 simple steps to get PlexVPN and watch Netflix videos',
    steps_item1: 'Create a PlexVPN account, then download PlexVPN and sign in your account',
    steps_item2: 'Select the server tagged with Netflix and connect to it',
    steps_item3: 'Sign in your Netflix account and watch the 4K videos',
    review_title: 'Reviews',
    feature_title: 'Features of PlexVPN',
    features_title1: 'Bypass GEO restrictions',
    features_title2: 'Gigabit acceleration, unlimited bandwidth',
    features_title3: 'High-quality servers all around the world',
    features_title4: 'Data encryption, no logs',
    features_title5: 'Support for multi-platform devices',
    features_title6: 'Friendly customer & technical support',
    features_con1: 'No matter where you are, PlexVPN can help you easily access the videos, music, social media, etc in any country/region anytime and anywhere without being restricted by copyright',
    features_con2: 'PlexVPN provides high-quality servers to unlock mainstream video websites, such as Netflix, Hulu, BBC iPlayer, etc. With our high-speed and stable servers, you can watch ultra HD videos smoothly, without any delay or buffering. And there is no bandwidth and traffic limit.',
    features_con3: 'PlexVPN provides servers all around the world. There are multiple servers in each country and region, if an IP is blocked by Netflix, you can connect to another server and continue to watch your favorite videos.',
    features_con4: 'With the latest & strongest ECC encryption technology, PlexVPN can hide your IP address and encrypt your network data. No one knows what you are doing. The strict no-logs policy will not log your data.',
    features_con5: 'PlexVPN has user-friendly clients for Android, iOS, macOS, Ubuntu, and Android TV devices. Users can enjoy the cross-platform use of mobile phones, tablets, and computers.',
    features_con6: 'If you encountered any problems while using PlexVPN, or you have any suggestions or advice for us, you can contact our customer support team via online feedback in the APP.',
    faqs_title: 'FAQs for Netflix',
    faqs_title1: 'Why do I need PlexVPN to watch Netflix videos?',
    faqs_con1: 'Netflix gets your location with your IP address. And uses your location to determine which TV shows and movies you can watch, and restrict which TV shows and movies you can watch. This is the so-called GEO restriction. It is what causes you to see annoying error messages on the screen.',
    faqs_des1: '"Whoops, something went wrong...You seem to be using an unblocker or proxy. Please turn off any of these services and try again. For more help, visit netflix.com/proxy."',
    faqs_des2: 'However, you can easily change your location with PlexVPN. You can install PlexVPN on your devices, then connect to the servers in other countries to unlock the Netflix restrictions.',
    faqs_title2: 'How to use PlexVPN to access Netflix?',
    faqs_con2: 'It is very simple! If you hope to access the Netflix library in the United States, French, the United Kingdom, Netherland, Japan, Australia, or India, you just need to connect to any server which is tagged with Netflix in that country. PlexVPN will provide you the IP address of the country/region automatically to help you unlock all local Netflix content.',
    faqs_title3: 'Which device can I use to watch Netflix videos?',
    faqs_con3: 'You can use PlexVPN on almost any device. PlexVPN has user-friendly clients for Android, iOS, macOS, Ubuntu, and Android TV devices.',
    faqs_title4: 'What else can I do with PlexVPN?',
    faqs_con4: 'With PlexVPN, you also can bypass censorship in certain countries and browse the web safely, including Netflix, Hulu, Amazon Prime Video, Disney+ and HBO Go, etc.',
    footer_con1: 'User praise/trust rating',
    reviews_user1: 'Jesse Elizondo',
    reviews_data1: '2020.05.24',
    reviews_con1: '\"The Plex VPN works consistently well and is one of my favs.\"',
    reviews_user2: 'Camara Abou Mohamed',
    reviews_data2: '2019.03.21',
    reviews_con2: "\"I love plexVPN because of its best design colour .And it's develop others app including the profile e.t.c\"",
    reviews_user3: 'Ehsan Muhammad',
    reviews_data3: '2020.05.05',
    reviews_con3: "\"Dear vpn Developer, you are the best among all vpn Developers.. World's best vpn Plexvpn. G Hats off to you all the team..\"",
    reviews_user4: 'Kenneth Mugwanya',
    reviews_data4: '2019.05.14',
    reviews_con4: '\"Supper fast connection Speed VPN I liked it in the first installation. 5/5 stars. Highly recommended. Thanks developer Team.\"',
    reviews_user5: 'Nouman Nomi',
    reviews_data5: '2020.08.12',
    reviews_con5: '\"Its good vpn. I like this.very easy to connect and quickly response\"',
  },
  zh: {
    banner_title: '如何使用PlexVPN观看Netflix',
    banner_des: '喜欢的电视节目或电影已在Netflix上线但是在你所在地区的Netflix资源库却找不到？这是因为Netflix在每个国家/地区的资源库都不尽相同，如果您想查看来自其他地区的内容，则需要使用PlexVPN来更改您的地理位置。PlexVPN具有大量服务器，可以持续绕过Netflix的地理限制，并让您快速流畅地观看喜欢的视频。',
    banner_btn: '立即获取PlexVPN',
    benefit_title: '使用PlexVPN观看Netflix的好处',
    benefit_item1: '突破封锁，自由观看各个国家/地区Netflix',
    benefit_item2: '高速稳定，HD / 4K视频流畅观看',
    benefit_item3: '无限流量，观看Netflix的理想选择',
    getPlex: '立即获取PlexVPN',
    downloadPlex: '下载PlexVPN',
    steps_title: '3个简单步骤获得PlexVPN并观看全球Netflix',
    steps_item1: '注册PlexVPN并下载客户端登陆账号',
    steps_item2: '选择国家/地区的Netflix高速专线进行连接',
    steps_item3: '登录到您的Netflix帐户，观看4k高清视频',
    review_title: '用户评论',
    feature_title: '为什么选择PlexVPN',
    features_title1: '绕过地理封锁的内容',
    features_title2: '千兆加速，无限流量',
    features_title3: '优质服务器遍布全球',
    features_title4: '数据加密，无日志',
    features_title5: '设备兼容，易于使用',
    features_title6: '友好的客服 & 技术支持',
    features_con1: '无论你身在何处，PlexVPN可以随时随地帮您轻松访问任何国家/地区的视频、音乐、社交媒体等，而不受版权地域的限制。',
    features_con2: 'PlexVPN提供Netflix、Hulu、BBC iPlayer等主流视频网站专线，高速稳定，因此即使是超高清视频也可以流畅播放，不会出现延迟或缓冲，而且没有宽带和流量限制。',
    features_con3: 'PlexVPN拥有全球服务器，由于其在每个国家都拥有多台服务器，因此如果一个IP被Netflix封锁，您还可以连接到另一台服务器，继续观看自己喜欢的节目。',
    features_con4: 'PlexVPN通过最新、最强的椭圆曲线加密技术，隐藏您的IP地址并加密您的网络数据，因此没人能看到您在做什么。严格的无日志政策不会记录您的数据。',
    features_con5: 'PlexVPN拥有 Android、iOS、Window、MacOS，Ubuntu及Android TV等客户端，界面友好，简单易用。还可手机，平板，电脑跨平台使用！',
    features_con6: '使用过程中遇到任何问题，或者您对 PlexVPN 有任何的意见或者建议，都可以通过客户端在线反馈联系我们。',
    faqs_title: 'Netflix常见问题',
    faqs_title1: '为什么需要PlexVPN观看Netflix？',
    faqs_con1: 'Netflix使用您的IP地址来查知您的位置。并通过您的位置来决定您可以观看哪些电视节目和电影，以及限制您观看哪些电视节目和电影。这就是所谓的地理限制，也是导致您在屏幕上看到烦人的错误消息的原因。',
    faqs_des1: '\“糟糕，出了点问题……您似乎正在使用解锁程序或代理。 请关闭这些服务，再重新尝试。\”',
    faqs_des2: '然而，您可以使用PlexVPN轻松更改您的Netflix位置。您可以直接在设备上安装PlexVPN客户端，连接其他国家的服务器，然后解除Netflix影音库的限制。',
    faqs_title2: '如何使用PlexVPN访问Netflix？',
    faqs_con2: '这很简单！如果要访问美国，法国，英国，荷兰，日本，澳大利亚或印度的Netflix库，只需连接到该国家/地区的任何服务器即可。PlexVPN会自动为您提供该国家/地区的IP地址，进而帮助您解锁当地Netflix所有内容。',
    faqs_title3: '我可以在哪些设备上观看Netflix？',
    faqs_con3: '您几乎可以在任何设备上使用PlexVPN。不管操作系统是 Android、iOS、Window、MacOS，Ubuntu 还是 Android TV，PlexVPN 都拥有操作简便的客户端。',
    faqs_title4: '使用PlexVPN还能做什么？',
    faqs_con4: '借助PlexVPN，您可以绕过某些国家/地区的审查制度，并安全地浏览网络，包括Netflix，Hulu，Amazon Prime Video，Disney +和HBO Go之类的服务。',
    footer_con1: '用户好评度/信任等级',
    reviews_user1: 'AE chihiro',
    reviews_data1: '2020年6月17日',
    reviews_con1: '\“买了会员了，体验很好。在 PC上 看油管 4K 没问题，手机上我用被限速的 4G 照样流畅观看 720P。\”',
    reviews_user2: 'Uriah Cong',
    reviews_data2: '2020年05月24日',
    reviews_con2: '\“一直都好用！你们是支撑我在国内上网冲浪的精神支柱，请一定好好地做下去！24小时 VPN 没在怕的！\”',
    reviews_user3: 'Ava Lanche',
    reviews_data3: '2019年3月31日',
    reviews_con3: '\“速度比较稳定，价格也适中，客服也耐心，用了得两年了吧，希望能坚持下去！\”',
    reviews_user4: 'xingyu peng',
    reviews_data4: '2020年5月5日',
    reviews_con4: '\“速度真的很快，而且有活动，综合下来也不贵，关键是手机电脑都可以用，真的很好。\”',
    reviews_user5: 'yo moe',
    reviews_data5: '2019年5月14日',
    reviews_con5: '\“一直在用这个！感觉套餐价格比较能接受，而且连接很稳定，客服也是真的非常亲切耐心~加油＾０＾~\”',
    reviews_user6: 'NT.Tp.',
    reviews_data6: '2020年8月12日',
    reviews_con6: '\“一个美国的朋友推荐给我的，开了2个季度的会员。使用了大半年，挺好用，连接稳定没有广告。\”',
    
  }
}


// WEBPACK FOOTER //
// ./src/views/promotion/Netflix/lang.js